import { cn } from '@/utils';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { useEffect } from 'react';

const containerVariants = cva(
    'tw-relative tw-transition-all tw-p-6 tw-overflow-hidden',
    {
        variants: {
            variant: {
                default: 'tw-bg-white tw-rounded-md tw-w-[90%] tw-max-w-screen-2xl tw-mx-auto tw-flex tw-h-full tw-flex-1 tw-flex-col tw-mb-5',
                full: 'tw-bg-white tw-rounded-md tw-w-[90%] tw-max-w-screen-2xl tw-mx-auto tw-flex tw-h-full tw-flex-1',
                half: 'tw-w-1/2 tw-mx-auto'
            }
        },
        defaultVariants: {
            variant: 'default'
        }
    }
);

const Background = ({ className, children, heightOffset = 50 }) => {
    useEffect(() => {
        // Set the scrollbar-gutter when the component mounts
        const panelsContainer = $('.panels_container');

        if (!panelsContainer) {
            return;
        }

        panelsContainer.css('scrollbar-gutter', 'stable');

        // Cleanup the style when the component unmounts
        return () => {
            panelsContainer.css('scrollbar-gutter', '');
        };
    }, []);

    return (
        <div
            className={cn(
                `tw-flex tw-justify-center tw-items-start tw-flex-col tw-py-10 tw-bg-grey-bg`,
                className
            )}
            style={{ minHeight: `calc(100vh - ${heightOffset}px)` }}
        >
            {children}
        </div>
    );
};

const Container = React.forwardRef(({ className, variant, children, ...props }, ref) => {
    return (
        <div className={cn(containerVariants({ variant }), className)} ref={ref} {...props}>
            {children}
        </div>
    );
});

Container.displayName = 'Container';

export { Background, Container, containerVariants };
